<template>
    <div>
        <div class="bg-overlay light-bg"></div>
        <div class="account-pages my-5 pt-5">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-6 col-md-8">
                        <div class="card border" style="border: 5px solid #f1f5f7; !important">
                            <div class="card-body p-4">
                                <div class="">
                                    <div class="text-center">
                                        <img src="images/logo.png" style="width:30%"/>
                                    </div>
                                    <h4 class="font-size-18 text-muted mt-3 text-center">Gubuk Sains Prima</h4>
                                    <p class="mb-2 text-center">Daftar Akun untuk lanjut ke aplikasi</p>
                                    <form class="form-horizontal" v-on:submit.prevent="onSubmit">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="mb-2">
                                                    <label class="col-form-label col-form-label-thick">Email </label>
                                                    <div class="input-icon input-icon-left input-icon-left-form-naked">
                                                        <i class="ph-user-bold"></i>
                                                        <input autocomplete="email" type="text"
                                                            class="form-control form-control-naked fcn-w-bb w-100 d-block"
                                                            :class="{ 'is-invalid': submitted && $v.username.$error }" v-model="username" placeholder="Masukan Email...">
                                                            <div v-if="submitted && !$v.username.required" class="invalid-feedback">Email wajib diisi!</div>    
                                                    </div>
                                                </div>
                                                <div class="mb-2">
                                                    <label class="col-form-label col-form-label-thick">Nama Lengkap </label>
                                                    <div class="input-icon input-icon-left input-icon-left-form-naked">
                                                        <i class="ph-user-bold"></i>
                                                        <input type="text"
                                                            class="form-control form-control-naked fcn-w-bb w-100 d-block"
                                                            :class="{ 'is-invalid': submitted && $v.name.$error }" v-model="name" placeholder="Masukan Nama Lengkap...">
                                                            <div v-if="submitted && !$v.name.required" class="invalid-feedback">Nama Lengkap wajib diisi!</div>    
                                                    </div>
                                                </div>
                                                <div class="mb-2">
                                                    <label class="col-form-label col-form-label-thick">Password </label>
                                                    <div class="input-icon input-icon-left input-icon-left-form-naked">
                                                        <i class="ph-lock-bold"></i>
                                                        <input autocomplete="current-password" type="password"
                                                            class="form-control form-control-naked fcn-w-bb w-100 d-block"
                                                            :class="{ 'is-invalid': submitted && $v.password.$error }" v-model="password" placeholder="Masukan Password...">
                                                            <div v-if="submitted && !$v.password.required" class="invalid-feedback">Password wajib diisi!</div>
                                                    </div>
                                                </div>
                                                <div class="mb-2">
                                                    <label class="col-form-label col-form-label-thick">Ulangi Password</label>
                                                    <div class="input-icon input-icon-left input-icon-left-form-naked">
                                                        <i class="ph-lock-bold"></i>
                                                        <input autocomplete="current-re_password" type="password"
                                                            class="form-control form-control-naked fcn-w-bb w-100 d-block"
                                                            :class="{ 'is-invalid': submitted && $v.re_password.$error }" v-model="re_password" placeholder="Ulangi Password...">
                                                            <div v-if="submitted && !$v.re_password.required" class="invalid-feedback">Ulangi password wajib diisi!</div>
                                                    </div>
                                                </div>
                                                <div class="form-check">
                                                    <input type="checkbox" class="form-check-input" id="term-conditionCheck" v-model="checkAggrement">
                                                    <label class="form-check-label fw-normal" for="term-conditionCheck">
                                                        Dengan mendaftar, kamu setuju dengan
                                                        <a href="https://gsprima.com/#/term-conditions" target="blank" class="text-primary">Syarat Ketentuan</a>
                                                        dan
                                                        <a href="https://gsprima.com/#/privacy-policy" target="blank" class="text-primary">Privasi dan kebijakan</a>
                                                    </label>
                                                </div>
                                                <div class="d-grid mt-3">
                                                    <button :disabled="waiting" type="submit" class="btn btn-primary waves-effect waves-light" :class="!checkAggrement ? 'disabled':''">
                                                        {{ waiting ? 'Harap tunggu ...' : 'Daftar Ke Aplikasi' }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row text-center mt-3">
                                            <div class="col font-weight-bold">
                                                Sudah punya akun ? <router-link :to="{name : 'signin'}">Login disini</router-link>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end row -->
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required
    } from "vuelidate/lib/validators";

    export default {
        name: 'Signup',
        metaInfo: {
            title: 'Signup',
            titleTemplate: '%s - Gubuk Sains Prima'
        },
        data() {
            return {
                username: "",
                name: "",
                password: "",
                re_password: "",
                checkAggrement: false,
                submitted: false,
                waiting: false,
            }
        },
        mounted () {
            document.body.classList.add('bg-pattern')
        },
        validations: {
            username: {
                required
            },
            name: {
                required
            },
            password: {
                required
            },
            re_password: {
                required
            },
        },
        methods: {
            onSubmit: function () {
                this.waiting = true;
                this.submitted = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Harap lengkapi form',
                    });

                    this.waiting = false;
                    return;
                } else {
                    this.$http.post(process.env.VUE_APP_APIHOST + 'auth/signup', {
                            username: this.username,
                            name: this.name,
                            password: this.password,
                            re_password: this.re_password
                        })
                        .then(response => {
                            this.waiting = false;

                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    html: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        const token = response.data.user.key;
                                        localStorage.setItem('gsprima_token', token);
                                        location.reload();
                                    }
                                });
                            }else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                        })
                }
            }
        }
    }
</script>